module.exports = require("./dist/ocLazyLoad.min.js");


//////////////////
// WEBPACK FOOTER
// oclazyload (bower component)
// module id = 407
// module chunks = 0